import { render, staticRenderFns } from "./TilauslomakeMuutosturva.vue?vue&type=template&id=1496e048&"
import script from "./TilauslomakeMuutosturva.vue?vue&type=script&lang=js&"
export * from "./TilauslomakeMuutosturva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports